import track from "../../track";
var FOOCMASK_TIMEOUT_EVENT_ID = 277;
var FOOCMASK_DURATION_EVENT_ID = 278;
export var trackFoocMaskTimeoutEvent = function() {
    track(FOOCMASK_TIMEOUT_EVENT_ID, true);
};
export var trackFoocMaskDurationEvent = function(timeDuration) {
    track(FOOCMASK_DURATION_EVENT_ID, timeDuration);
};

//# sourceMappingURL=analytics.js.map